// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Tydk","info":"UpdateTermsInfo_info__2VIWi"};